// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumbs {
  font-size: 12px;
  text-transform: uppercase;
  color: var(--colorTextMuted);
  margin-left: -4px;
  line-height: 10px;
  padding: 0;
}
.breadcrumbs .item {
  display: inline-block;
  margin: 4px;
  line-height: 1.5;
  word-break: break-all;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
